//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[],[[[],"Dispose",{},0,0],[["regionData","nParentCurves","parentCurves","nVertexIndices","vertexIndices","nNormalIndices","normalIndices","nVertices","vertices","nNormals"],"GetAllRegionData",{R_:{normals:""}},0,0]],[]];
SPLM.GeometricUtilities.RegionRecognitionData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.RegionRecognitionData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.RegionRecognitionData.RegionData = class{
    constructor(seedObject,pointOnRegion,regionType){
        this.seedObject=seedObject;this.pointOnRegion=pointOnRegion;this.regionType=regionType;}
    get Seedobject(){return this.seedObject}
    set Seedobject(val){this.seedObject = val}
    get Pointonregion(){if(this.pointOnRegion === undefined) this.pointOnRegion = new SPLM.Point3d(); return this.pointOnRegion}
    set Pointonregion(val){this.pointOnRegion = val}
    get Regiontype(){return this.regionType}
    set Regiontype(val){this.regionType = val}
};

SPLM.GeometricUtilities.RegionRecognitionData.Type = Object.freeze({
    "Sketch" : "Sketch", "Face" : "Face"});

export default SPLM;